import React, { useRef } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../components/common/Footer";
import Header from "../../components/common/Header";
import NavBar from "../../components/common/NavBar";
import SideSectionFrame from "../../components/common/SideSectionFrame";
import ProposalInfoCard from "../../components/proposal/ProposalInfoCard";
import ProposalStatCircleCard from "../../components/proposal/ProposalStatCircleCard";
import ReviewCard from "../../components/proposal/ReviewCard";
import TeamInfoCard from "../../components/proposal/TeamInfoCard";
import ProjectDetail from "../../components/proposal/ProjectDetail";
import { useSingleProposalData } from "../../lib/hooks";
import { SingleProposalFormType } from "../../lib/proposalAPI";
import { Alert } from "@mui/material";
import ProposalDetailLoadingIndex from "./ProposalDetailLoadingIndex";
import ProposalVideo from "../../components/proposal/ProposalVideo";
// import PropodalMedia from "../../components/proposal/ProposalMedia";
// import ProjectAmountPercentage from "../../components/proposal/ProjectAmountPercentage";

const ProposalDetailIndex = () => {
  let params = useParams();
  const proposalid: number = +params.proposalid!;

  const formData = useRef<SingleProposalFormType>({
    proposal_id: proposalid,
  });

  const { loading, error, proposalData } = useSingleProposalData(
    formData.current
  );

  return (
    <>
      <NavBar />
      {loading && <ProposalDetailLoadingIndex />}
      {!loading && error && (
        <div>
          <Alert severity="error">{error}</Alert>
        </div>
      )}
      {!loading && error === null && (
        <>
          <Header
            isChallengeProposal={proposalData.is_challenge_proposal}
            pageName={proposalData.proposal_name}
            pageDesc={proposalData.proposal_description}
            funded={proposalData.funded_status}
          />
          <SideSectionFrame
            leftSection={
              <>
                <ProposalInfoCard
                  proposalTitle={proposalData.proposal_name}
                  rating={proposalData.rating}
                  funded_status={proposalData.funded_status}
                  fund_name={proposalData.fund_name}
                  challenge_name={proposalData.challenge_name}
                  user_name={proposalData.user_name}
                  solution={proposalData.solution}
                  fund_id={proposalData.fund_id}
                  challenge_id={proposalData.challenge_id}
                  url={proposalData.url}
                  amount_requested={proposalData.amount_requested}
                  no_assessments={proposalData.no_assessments}
                />
                <TeamInfoCard
                  user_name={proposalData.user_name}
                  experience={proposalData.experience}
                  user_id={proposalData.user_id}
                />
                <ProposalStatCircleCard
                  title="Voting Statistics"
                  vote={true}
                  desc2="Down Votes: "
                  val2={proposalData.no_votes}
                  desc1="Up Votes: "
                  val1={proposalData.yes_votes}
                  desc3="Result Votes: "
                  val3={proposalData.result_votes}
                  valSub={proposalData.yes_votes}
                  valTotal={proposalData.no_votes + proposalData.yes_votes}
                />

                {/* <ProgressCard /> */}
                {/* <Divider
                  sx={{ display: { md: "none" }, orientation: "horizontal" }}
                /> */}
              </>
            }
            rightSection={
              <>
                {proposalData.funded_status && (
                  <ProposalStatCircleCard
                    vote={false}
                    title="Project Funding Distribution Status"
                    desc1="Amount Distributed: "
                    val1={proposalData.project_info.amount_distributed}
                    desc2="Amount Remaning: "
                    val2={proposalData.project_info.amount_remaining}
                    valSub={
                      proposalData.project_info.amount_distributed -
                      proposalData.project_info.amount_remaining
                    }
                    valTotal={proposalData.project_info.amount_distributed}
                  />
                )}

                <ProjectDetail projectDetail={proposalData.project_info} />

                {proposalData.videos.length > 0 && (
                  <ProposalVideo videos={proposalData.videos} />
                )}

                {/* {proposalData.media.length > 0 && (
                  <PropodalMedia media={proposalData.media} />
                )} */}

                <ReviewCard
                  assessments={proposalData.assessments}
                  no_assessments={proposalData.no_assessments}
                />
              </>
            }
          ></SideSectionFrame>
        </>
      )}
      <Footer />
    </>
  );
};

export default ProposalDetailIndex;
